module.exports = __webpack_public_path__ + "img/99.cb4f8855.jpg";